import React from 'react'
import VehicleBasedIntegrations from '../vehicleBasedIntegrations/VehicleBasedIntegrations'
import { useIntegrationDocsURL } from '../../../../../../utils/docs'

const Mapon: React.FC = () => {
  const integrationDocs = useIntegrationDocsURL()

  return (
    <VehicleBasedIntegrations
      allowAuthentication
      credentialsRequestUrl="/mapon/authentication/{companyId}"
      getVehiclesUrl="/mapon/vehicles/{companyId}"
      updateVehicleUrl="/mapon/vehicles/{companyId}/{id}"
      pageDocsUrl={integrationDocs.external('mapon')}
      name="mapon"
    />
  )
}

export default Mapon
